export default "__VITE_ASSET__R9RUrusy__"